import { createIcon } from '@chakra-ui/react';

export const PaidOutIcon = createIcon({
  displayName: 'PaidOutIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
      <path
        d="M1.66602 7.08325H12.0827"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 13.75H6.66667"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 13.75H12.0833"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3327 11.6917V13.4251C18.3327 16.3501 17.591 17.0834 14.6327 17.0834H5.36602C2.40768 17.0834 1.66602 16.3501 1.66602 13.4251V6.57508C1.66602 3.65008 2.40768 2.91675 5.36602 2.91675H12.0827"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.666 7.91675V2.91675L18.3327 4.58341"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 2.91675L15 4.58341"
        stroke="#3F3F46"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});
